module.exports = __webpack_public_path__ + "static/media/down-arrow.a2290488.svg";